import {
  isArray,
  isUndefined,
  isString,
  isNumber,
  isObject,
  isFunction,
  forEach,
  merge,
  deepMerge,
  extend,
} from "axios/lib/utils";

export {
  isArray,
  isUndefined,
  isString,
  isNumber,
  isObject,
  isFunction,
  forEach,
  merge,
  deepMerge,
  extend,
};

export function isPlainObject(val) {
  return val && val.constructor.name === "Object";
}

/**
 * 向目标对象赋值，仅对目标对象target的key赋值，源source多余的key不会添加到target上
 * @param {object} target 待赋值目标对象
 * @param {object} source 赋值目标源
 */
export function assignment(target, source) {
  if (!isPlainObject(target) || !isPlainObject(source)) {
    return target;
  }

  for (let key in target) {
    if (!isUndefined(source[key])) {
      if (isPlainObject(target[key])) {
        target[key] = assignment(target[key], source[key]);
      } else {
        target[key] = source[key];
      }
    }
  }

  return target;
}

// 格式化日期
export const dateFormat = function (date, format) {
  if (typeof date === "string") {
    date = date - 0 || (!/\d+T\d+/.test(date) ? date.replace(/-/g, "/") : date);
  }

  const d = new Date(date);
  if (!date || d.toUTCString() === "Invalid Date") {
    return "";
  }

  var map = {
    y: d.getFullYear(), // 年
    M: d.getMonth() + 1, //月
    d: d.getDate(), //日
    h: d.getHours(), //时
    m: d.getMinutes(), //分
    s: d.getSeconds(), //秒
    S: d.getMilliseconds(), //毫秒
    q: Math.floor((d.getMonth() + 3) / 3), //季度
  };

  return format.replace(/([yMdhmsqS])\1*/g, function (m, t) {
    var v = String(map[t]);

    if (t === "y") {
      return v.substr(4 - m.length);
    } else if (t === "S") {
      return ("00" + v).substr(v.length - 1);
    } else if (m.length > 1) {
      return ("0" + v).substr(v.length - 1);
    }

    return v;
  });
};

export const month = (date) => dateFormat(date, "yyyy-MM");
export const date = (date) => dateFormat(date, "yyyy-MM-dd");
export const datetime = (date) => dateFormat(date, "yyyy-MM-dd hh:mm:ss");

export const GoTop = function () {
  (function smoothscroll() {
    var currentScroll =
      document.documentElement.scrollTop || document.body.scrollTop;
    if (currentScroll > 0) {
      window.requestAnimationFrame(smoothscroll);
      window.scrollTo(0, currentScroll - currentScroll / 10);
    }
  })();
};



// WEBPACK FOOTER //
// ./src/utils/assist.js